import React from "react";
import { FiCheck } from "react-icons/fi";
import { HStack, Icon, Text } from "@chakra-ui/react";

function JobInvited({ invited, ...props }) {
  return invited && (
    <HStack
      p="4px 8px"
      borderRadius="6px"
      bg="white"
      alignItems={"center"}
      height="32px"
      gap="0.3rem"
      {...props}>
      <Icon as={FiCheck} boxSize="16px" color="gray.900"/>
      <Text fontSize="14px" color="gray.900" fontWeight="500">Invited</Text>
    </HStack>
  );
}

export default JobInvited;